import { MyMattersDashboardTabView } from "@/components/features/matters/MyMattersDashboardTabView";
import { GlobalNotAuthorized, Text } from "@/components/ui";
import { useUser } from "@/components/UserProvider";
import { PAGE_PERMISSION_KEYS } from "@/lib/data/static/permissionOptions";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/matters/my-matters")({
  component: RouteComponent,
});

function RouteComponent() {
  const { hasPagePermission } = useUser();

  if (!hasPagePermission(PAGE_PERMISSION_KEYS.mattersMy)) {
    return <GlobalNotAuthorized />;
  }

  return (
    <MyMattersDashboardTabView
      topContent={
        <Text as="h1" variant="title" className="mb-6 shrink-0">
          My matters
        </Text>
      }
    />
  );
}
